import { Dispatch, SetStateAction } from 'react';

export const toggleModal =
  (set: Dispatch<SetStateAction<boolean>>, func?: VoidFunction): VoidFunction =>
  (): void => {
    set((prevState: boolean) => !prevState);

    func?.();
  };
